// extracted by mini-css-extract-plugin
export default {"logo":"Sidebar_logo__7Peuv","titleLogo":"Sidebar_titleLogo__p1edm","sizeIcons":"Sidebar_sizeIcons__-4uku"};